export default __webpack_public_path__ + "static/Image042_small-999bbbf46ba52aa732b2567ef413187a.png";